import { FC } from "react";

interface HtmlContentProps {
    html: string | null | undefined;
    className?: string;
}

/** What the admin rich-text editor produces for empty content, before and after server-side sanitizing. */
const EMPTY_HTML_PATTERN = /^\s*(<p>\s*(<br\s*\/?>)?\s*<\/p>\s*)*$/i;

/**
 * Renders rich-text HTML produced by the admin editor. The markup is sanitized server-side before it is
 * persisted, so this is the only place the client is allowed to inject HTML.
 */
const HtmlContent: FC<HtmlContentProps> = ({ html, className }) => {
    if (!html || EMPTY_HTML_PATTERN.test(html)) {
        return null;
    }

    return (
        <div
            className={`html-content${className ? ` ${className}` : ""}`}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

export default HtmlContent;
